var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScaleZone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.006,
    cy: 16.006,
    r: 14.946,
    fill: "#7f7f7f",
    stroke: "#333",
    strokeWidth: 2.1087
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.3284 -4.3284 4.3284 -4.3284 -36.134 -15.471)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.010814 -.0030931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-7.5012 2.3899-0.76696 0.4428v-0.8856l0.38348 0.2214z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1,1)",
    d: "m11.798 2.3899-0.76696 0.4428v-0.8856l0.38348 0.2214z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -11.406,
    y: 2.1538,
    width: 3.4907,
    height: 0.4662
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleZone);
export default __webpack_public_path__ + "static/media/scale_zone.b7a2582947931a1d671cec16299b3bbf.svg";
export { ForwardRef as ReactComponent };